
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationAssembliesNote: {
    id: "Assemblies.note",
    defaultMessage: "Note:",
  },
  configurationAssembliesNoteMessageWith: {
    id: "Assemblies.message.with",
    defaultMessage: "All assembly accessories are designed for solid walls only.",
  },
  configurationAssembliesNoteMessageWithout: {
    id: "Assemblies.message.without",
    defaultMessage: "Mounting by customer.",
  },
  configurationAssembliesNoteMessageWithoutTriggerSafety: {
    id: "Assemblies.message.alwaysTriggerSafety",
    defaultMessage: "Trigger safety always included.",
  },
  assemblyTitle: {
    id: 'ConfigurationDetail.ApronBacksplash.assemblyTitle',
    defaultMessage: 'Assembly accessories',
  },
  assemblyBtnSelection: {
    id: 'ConfigurationDetail.ApronBacksplash.assemblyBtnSelection',
    defaultMessage: 'Selection',
  },
  assemblyBtnAssemblyAccessories: {
    id: 'ConfigurationDetail.ApronBacksplash.assemblyBtnAssemblyAccessories',
    defaultMessage: 'Assembly Accessories',
  },
});

export default MESSAGES;